import { Base64 } from "js-base64"
const field = 'web_'
const keysNeedEncrypt = ["accountname", "password", "peopleId", "userId", "tenantId", "tenantSign", "tenantInfo", "tabkey", "connKey"]

class LocalStorages { // 用户端和管理端id, token分离
  setItem(key, value = '') {
    if (keysNeedEncrypt.includes(key)) {
      value = Base64.encode(String(value))
    }
    localStorage.setItem(`${field}${key}`, value);
  }
  getItem(key) {
    let value = localStorage.getItem(`${field}${key}`);
    if (keysNeedEncrypt.includes(key) && value) {
      value = Base64.decode(value)
    }
    return value
  }
  removeItem(key) {
    localStorage.removeItem(`${field}${key}`);
  }
}

export const localStorages = new LocalStorages()

class SessionStorages { // 用户端和管理端id, token分离
  setItem(key, value = '') {
    if (keysNeedEncrypt.includes(key)) {
      value = Base64.encode(String(value))
    }
    sessionStorage.setItem(`${field}${key}`, value);
  }
  getItem(key) {
    let value = sessionStorage.getItem(`${field}${key}`);
    if (keysNeedEncrypt.includes(key) && value) {
      value = Base64.decode(value)
    }
    return value
  }
  removeItem(key) {
    sessionStorage.removeItem(`${field}${key}`);
  }
}

export const sessionStorages = new SessionStorages()



// WEBPACK FOOTER //
// ./src/utils/localStorages.js